<div class="pivot-card">
  <div class="pivot-card-content">
    <div class="pivot-card-header">
      <div class="pivot-card-title-row">
        <hyperkit-typography variant="label1" color="primary">
          {{ title }}
        </hyperkit-typography>

        <!-- <span *ngIf="source" class="pivot-card-label" [ngClass]="source">
          <span class="emoji">{{ getSourceLabelParts(source)?.icon }}</span>
          <span class="text">{{ getSourceLabelParts(source)?.text.toUpperCase() }}</span>
        </span> -->
      </div>

      <hyperkit-typography variant="body2" color="secondary">
        {{ description }}
      </hyperkit-typography>
    </div>
  </div>

  <div class="pivot-card-action">
    <hyperkit-button
      *ngIf="selected"
      variant="standard"
      color="secondary"
      size="small"
      text="Remove from Hunt"
      icon="check"
      iconPosition="left"
      (click)="onToggleSelection()"
    ></hyperkit-button>

    <hyperkit-button
      *ngIf="!selected"
      variant="standard"
      color="secondary"
      size="small"
      text="Add to Hunt"
      (click)="onToggleSelection()"
    ></hyperkit-button>

  </div>
</div>